import React from "react";
import styles from "./TextStyle.module.scss";
import clsx from "clsx";

export interface TextStyleProps {
  textAlign?: "left" | "center" | "right";
  fontSize: "small" | "medium" | "large" | "disclaimer" | "inherit";
  boxed?: boolean;
  fontSizeResponsive?: boolean;
  className?: string;
}

export const TextStyle: React.FC<React.PropsWithChildren<TextStyleProps>> = ({
  boxed = false,
  fontSize = "medium",
  textAlign,
  fontSizeResponsive = false,
  className,
  children
}) => {
  return (
    <div
      className={clsx(styles.container, className, {
        [styles.isBoxed]: boxed,
        [styles.isResponsive]: fontSizeResponsive,
        [styles.fontSizeSmall]: fontSize == "small",
        [styles.fontSizeMedium]: fontSize == "medium",
        [styles.fontSizeLarge]: fontSize == "large",
        [styles.fontSizeDisclaimer]: fontSize == "disclaimer",
        [styles.textAlignLeft]: textAlign == "left",
        [styles.textAlignCenter]: textAlign == "center",
        [styles.textAlignRight]: textAlign == "right"
      })}
    >
      {children}
    </div>
  );
};
